export default __webpack_public_path__ + "static/media/perge.93de240a.jpg";